import React from "react";
import GaugeChart from "react-gauge-chart/dist/GaugeChart";


class TextWidget extends React.Component {

    state = {
    }




    render() {

        return (
            <div className="w-100 py-2 px-2 h-100" >
                <p>This is a test text</p>
            </div >
        )
    }
}



export default TextWidget;
